module.exports = __webpack_public_path__ + "static/img/ic_right.44b0d8dd.svg";